import React, { useState } from 'react';

const clients = [
  {
    name: "Mortágua",
    logo: "https://static.lumi.new/26/264654feec9f8f1db9d09d2bf3cfd7b8.webp",
  },
  {
    name: "Santa Comba Dão",
    logo: "https://static.lumi.new/6f/6f853601cf7c8a0b8a11d60e1d0327d6.webp",
  },
  {
    name: "Penacova",
    logo: "https://static.lumi.new/68/682e900f3fe8494d236ac0cf251a9f76.webp",
  },
  {
    name: "Arganil",
    logo: "https://static.lumi.new/a5/a5086fae4c8d3527e07348e0b1c45791.webp",
  },
  {
    name: "Lousã",
    logo: "https://static.lumi.new/24/247330a98f0f71c828a3d5f940674254.webp",
  },
  {
    name: "Arouca",
    logo: "https://static.lumi.new/30/301f48c471ffca1958ab87ad3a600702.webp",
  },
  {
    name: "Seia",
    logo: "https://static.lumi.new/af/afd70db13dbb8b877b6693da3f93316e.webp",
  },
  {
    name: "Alvaiázere",
    logo: "https://static.lumi.new/c3/c341c826773a2d4abe66030e5fc1a414.webp",
  },
  {
    name: "Penalva do Castelo",
    logo: "https://static.lumi.new/6e/6e36a7bc6c1f0493aa1628a72832e92f.webp",
  },
  {
    name: "Tábua",
    logo: "https://static.lumi.new/99/99c4a69995457e24145a7199666362aa.webp",
  },
  {
    name: "Tondela",
    logo: "https://static.lumi.new/8c/8c4876e95ec0b5526712dce0d662cd77.webp",
  },
  {
    name: "Oliveira de Frades",
    logo: "https://static.lumi.new/27/2746c8f874dd1d641e4cd74a7ce52016.webp",
  },
  {
    name: "Proença-a-Nova",
    logo: "https://static.lumi.new/19/19ff34078d58288e7c679433bb3fb2b8.webp",
  },
  {
    name: "Baldios Coelhoso",
    logo: "https://static.lumi.new/a4/a4778113fc751aefe3838249cf5c3439.webp",
  },
  {
    name: "Girabolhos",
    logo: "https://static.lumi.new/2f/2fdad01d545ece87443932fb1a4a5b1f.webp",
  },
];

function ClientLogo({ name, logo }: { name: string; logo: string }) {
  const [failed, setFailed] = useState(false);
  const initials = name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return (
    <div className="flex flex-col items-center gap-4 p-6 bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:-translate-y-1 transition-all duration-300 group">
      <div className="w-24 h-24 flex items-center justify-center">
        {failed ? (
          <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center text-green-800 font-bold text-2xl">
            {initials}
          </div>
        ) : (
          <img
            src={logo}
            alt={`Brasão de ${name}`}
            className="w-24 h-24 object-contain drop-shadow-sm group-hover:scale-105 transition-transform duration-300"
            onError={() => setFailed(true)}
          />
        )}
      </div>
    </div>
  );
}

export default function Clients() {
  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      {/* Hero header */}
      <div className="bg-green-800 text-white pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 text-white text-sm font-semibold mb-4">
            Clientes
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">
            Alguns dos Nossos Clientes
          </h1>
          <p className="text-green-100 text-lg max-w-2xl mx-auto leading-relaxed">
            Trabalhamos com inúmeras entidades públicas e privadas de norte a sul do país.
          </p>
        </div>
      </div>

      {/* Logos grid */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {clients.map((client) => (
            <ClientLogo key={client.name} name={client.name} logo={client.logo} />
          ))}
        </div>
      </div>
    </div>
  );
}
